import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { UpaUserProfileDataModel, Validation } from '../../../Core/models';
import { SwProcessStateService, CommonService } from '../../../Core/Services';
import { TelephoneValidationService } from '../../../Core/Services/component/telephone-validation.service';

@Component({
  selector: '[app-telephone]',
  templateUrl: './telephone.component.html',
  styleUrls: ['./telephone.component.css']
})
export class TelephoneComponent implements OnInit {

  constructor(private swProcessStateService: SwProcessStateService, private telephoneValidationService: TelephoneValidationService, private commonService: CommonService) { }
  @Output() onSubmit: EventEmitter<string> = new EventEmitter<string>();
  public errorClass = '';
  public error: Validation = new Validation();
  private _telePhone: string = '';
  @Input() isUpaEnable: boolean = false;
  @Input() isUserLoggedIn: boolean = false;
  @Input() upaUserData: UpaUserProfileDataModel;

  ngOnInit() {
    this.telephoneValidationService.telephoneValid$.subscribe({
      next: (error) => {
        this.error.isInValid = error.isInValid;
        this.error.errorCss = error.errorCss
      }
    })
    this.swProcessStateService.isSW$.subscribe(isSw => {
      if (isSw) {
        this.swPhone();
      }
    })
  }
  swPhone() {
    this.swProcessStateService.swProcessModel$.subscribe(swInput => {
      this.telePhone = this.commonService.maskTelephone(swInput?.phone);
    })
  }

  ngOnChanges() {
    this.swProcessStateService.isSW$.subscribe(isSw => {
      if (this.isUpaEnable && this.isUserLoggedIn && !isSw) {
        let telephone: number = this.upaUserData.mobileNumber
        this.telePhone = telephone ? this.commonService.maskTelephone(telephone.toString()) : "";
        this.submitAnswer(telephone.toString());
      }
    })
  }

  submitAnswer(telephone: string) {
    this.onSubmit.emit(telephone)
    const isEmpty = !telephone || telephone.trim().length === 0;
    this.telephoneValidationService.updateEmptyStatus(isEmpty);
  }
  onClick($event) {
    if (isNaN($event.target.value)) {
      this.telePhone = '';
      this.telephoneValidationService.updateEmptyStatus(true);
    }
     
  }

  public get telePhone(): string {
    return this._telePhone;
  }

  public set telePhone(value: string) {
    this._telePhone = value;
    const isEmpty = !value || value.trim().length === 0;
    this.telephoneValidationService.updateEmptyStatus(isEmpty);
  }
}
